import { useEffect } from 'react';

/**
 * A higher order component that executes passed function on mount.
 * The component doesn't render anything.
 *
 * @example
 * ```
 * <OnMount run={() => { console.log('mounted'); }} />
 * ```
 *
 * @param {{ run: Function }} { run } A function to run on mount.
 * @returns null
 */
export function OnMount({ run }: { run: Function }) {
    useEffect(() => {
        if (run) {
            run();
        }
    }, []);

    return null;
}
